import {
  DELETE_MERCHANT_FAILED,
  DELETE_MERCHANT_SUCCESS,
  DELETE_MERCHANT_LOADING,
  DELETE_MERCHANT_REMOVE
} from "../types";

const initialState = {
  loading: false,
  error: null,
  status: null,
  message: null,
};

export const deleteMerchantReducer = (
  state = initialState,
  action: { type: any; loading: boolean, payload: any, error: any, status: string, message: string }
) => {
  switch (action.type) {
    case DELETE_MERCHANT_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case DELETE_MERCHANT_SUCCESS:
      //
      return {
        ...state,
        loading: false,
        status: action.payload?.code,
        message: action.payload?.message,
        error: null,
      };
    case DELETE_MERCHANT_FAILED:
      return {
        ...state,
        loading: false,
        status: null,
        message: null,
        error: action.error,
      };
    case DELETE_MERCHANT_REMOVE:
      return initialState;

    default:
      return state;
  }
};
